import request from './request'
// const activity_id = localStorage.getItem('activity_id')
export const get = (url, params = {}) => {
	// if (!params.activity_id) {
	//   params.activity_id = activity_id
	// }
	return request({
		url,
		method: 'GET',
		params
	})
}

export const post = (url, data = {}, headers = {
	'Content-Type': 'application/json;charset=UTF-8'
}) => {
	// if (!data.activity_id) {
	//   data.activity_id = activity_id
	// }
	console.log(headers,"header");
	return request({
		url,
		method: 'POST',
		data,
		headers
	})
}
